import React, { useState } from "react";
import dayjs from "dayjs";
import { dayjsLocalizer, dateFnsLocalizer } from "react-big-calendar";
import Calendar from "../Calendar";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "./BasicCalendar.css";
import { ReactElement, JSXElementConstructor, ReactNode } from "react";
import withDragAndDrop, {
  withDragAndDropProps,
} from "react-big-calendar/lib/addons/dragAndDrop";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useColor } from "./ColorContext";

// drag and drop functionality
const DnDCalendar = withDragAndDrop(Calendar);

const localizer = dayjsLocalizer(dayjs);
dayjs.extend(customParseFormat);

type BasicCalendarProps = {
  calendarEvents: Array<Object>;
};

type DnDCalendarProps = {
  events: Array<Object>;
  defaultView: string;
  views: Array<string>;
  toolbar: boolean;
  formats: {
    dayFormat: (date: Date) => string;
  };
  min: Date;
  max: Date;
  components: {
    event: (props: {
      title:
        | string
        | number
        | boolean
        | ReactElement<any, string | JSXElementConstructor<any>>
        | Iterable<ReactNode>
        | null
        | undefined;
      event: {
        start: Date;
        end: Date;
      };
    }) => JSX.Element;
  };
  draggableAccessor: (event: Object) => boolean;
  resizable: boolean;
  localizer: any;
};

export default function BasicCalendar({ calendarEvents }: BasicCalendarProps) {
  const { color } = useColor();

  const components = {
    event: (props: { title: any; event?: any }) => {
      const { title, event } = props;
      const startTime = dayjs(event.start).format("h:mm A");
      const endTime = dayjs(event.end).format("h:mm A");
      const eventType = "Event";

      switch (eventType) {
        case "Event":
          return (
            <div
              className="h-full p-2 bg-purple-50 rounded-xl border-4 text-black"
              style={{
                borderColor: color,
              }}
            >
              <h2 className="font-medium">{title}</h2>
              <p className="font-light text-sm">{`${startTime} - ${endTime}`}</p>
            </div>
          );
        // case "Course":
        //   return (
        //     <div className="h-full p-2 bg-orange-50 rounded-xl border-4 border-orange-500 text-black">
        //       <div className="bg-orange-500 max-w-fit p-1 rounded-lg text-white">
        //         <h2 className="font-medium">{title}</h2>
        //       </div>
        //       {/* <div className="py-1">
        //         <p className="font-light text-sm">{event.data.time}</p>
        //         <p className="font-light text-xs">
        //           Credits: {event.data.credit}
        //         </p>
        //         <p className="font-light text-xs">
        //           Instructor: {event.data.instructor}
        //         </p>
        //         <p className="font-light text-xs">
        //           Campus: {event.data.campus}
        //         </p>
        //         <p className="font-light text-xs">
        //           Location: {event.data.location}
        //         </p>
        //       </div> */}
        //     </div>
        //   );
        default:
          return null;
      }
    },
  };

  return (
    <section className="flex flex-col w-[1000px] min-h-[85dvh] bg-zinc-50 rounded-3xl overflow-auto border py-1 shadow">
      <div className="flex p-4 justify-center items-center relative">
        <div className="absolute hidden sm:block left-0 ml-4 py-2 px-4 rounded-2xl text-xs border shadow-sm font-normal">
          0 Credits
        </div>
        <button className="text-zinc-900 px-2 rounded-full border">
          {"<"}
        </button>
        <h2 className="font-normal tracking-wide mx-6">Spring Semester</h2>
        <button className="text-zinc-900 px-2 rounded-full border">
          {">"}
        </button>
      </div>
      <div className="bg-zinc-50 h-[100%]">
        <DnDCalendar
          events={calendarEvents}
          defaultView={"work_week"}
          views={["work_week"]}
          toolbar={false}
          formats={{
            dayFormat: (date) => dayjs(date).format("ddd"),
          }}
          min={dayjs("07:00", "H:m").toDate()}
          max={dayjs("21:00", "H:m").toDate()}
          components={components}
          resizable={true}
          localizer={localizer}
        />
      </div>
    </section>
  );
}
